export default "__VITE_ASSET__D9ylLuh8__"